<template>
  <div class="about">
    <h1>A site of events</h1>
  </div>
</template>
